const SET_RANGE = 'directOrderRecurring/SET_RANGE';

export default {
  // CHANGE_VALUES,

  SET_RANGE,
};
